export const API_ERROR_CODE = {
    INTERNAL_SERVER_ERROR: -1,
    DATA_IS_NULL: -2,
    DB_API_ERROR: -3,
    DATA_IS_INVALID: -4,
    DATA_HAVE_NO_REQUIRED: -5,
    DATA_HAVE_EXCLUSIVE: -6,

    PERMISSION_INVALID: -21,
    PERMISSION_NOT_MASTER: -22,
    PERMISSION_CANNOT_MATCH_PLACE: -23,

    TOKEN_EXPIRED: -31,
    TOKEN_INVALID: -32,

    LINK_NOT_MATCHED_TYPE: -51,

    DEVICE_CANNOT_COM: -100,
    DEVICE_NOT_CONNECTED: -101,
    DEVICE_ACTION_TIMEOUT: -102,
    DEVICE_CONTROL_ERROR: -103,
    NOT_MINIBIG_DEVICE: -104,

    USER_INVALID: -121,
    USER_NAME_EXiST: -122
}

export const API_SUCCESS_CODE = {
    API_SUCCESS: 0,
}

export const DEVICE_CONFIRM_CODE = {
    DEVICE_SUCCESS: 253,
    DEVICE_NOT_MATCHING: 255,
    DEVICE_BUSY: 254,
    DEVICE_NOT_INITIAL: 252,
    DEVICE_SAME_DIRECTION: 251,
    DEVICE_NOT_FOUND: 208,
    DEVICE_EXCEED_TIMER_NUM: 238,
}

export const AUTH_CODE = {
    AUTH_NOT_AUTHORIZATION: 'NotAuthorizedException'
}